import _get from 'lodash/get'
import getConfig from 'next/config'
import React, { type PropsWithChildren } from 'react'

import { APP_ENV, DATADOG_CLIENT_TOKEN, RUM_APPLICATION_ID, RUM_SERVICE_NAME } from '@/config/env'
import { shouldIgnoreError } from '@/utils/errorFiltering'
import { datadogRum } from '@datadog/browser-rum'

export const RUMProvider = (props: PropsWithChildren) => {
  const initRUM = React.useCallback(() => {
    const { publicRuntimeConfig } = getConfig()

    const getAllowList = (hosts: string[]) => {
      return hosts.map((host) => {
        return (url: string) => url.includes(host)
      })
    }

    return datadogRum.init({
      applicationId: RUM_APPLICATION_ID,
      clientToken: DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.eu',
      service: RUM_SERVICE_NAME,
      env: APP_ENV,
      version: publicRuntimeConfig?.appVersion,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: getAllowList(['api.gtsf.insure', 'api.getsafe.eu']),
      beforeSend: (event, context) => {
        if (event.type === 'error' && 'error' in context) {
          const errorMessage =
            _get(context, 'error.message', '') || _get(context, 'error.stack', '')
          const errorSource = _get(context, 'error.source', '')

          if (shouldIgnoreError(errorMessage, errorSource)) {
            return false
          }
        }

        return true
      },
    })
  }, [])

  React.useEffect(() => {
    if (APP_ENV === 'production') {
      initRUM()
    }
  }, [initRUM])

  return <div>{props.children}</div>
}
